function MFROffCanvasMenu(index, element) {
  this.$element = $(element)

  this.selectors = {
    offCanvasContainer: ".off-canvas__body",
    offCanvasMenu: "#mfr-offCanvasMenu",
    links: "#primary-links li > a",
    images: ".hover-image",
    hasSubMenu: "#primary-links .menu-item-has-children",
    subMenuTriggers: "#primary-links .sub-menu-trigger",
    ctas: ".sub-navigation .ctas a",
    tooltip: ".nav-tooltip"
  }

  this.init()
}

MFROffCanvasMenu.prototype = Object.assign({}, MFROffCanvasMenu.prototype, {
  init: function () {
    this.$offCanvasContainer = this.$element.find(this.selectors.offCanvasContainer)
    this.$offCanvasMenu = this.$element.find(this.selectors.offCanvasMenu)
    this.$images = this.$element.find(this.selectors.images)
    this.$links = this.$element.find(this.selectors.links)
    this.$hasSubMenu = this.$element.find(this.selectors.hasSubMenu)
    this.$subMenuTriggers = this.$element.find(this.selectors.subMenuTriggers)
    this.$ctas = this.$element.find(this.selectors.ctas)
    this.$tooltip = this.$element.find(this.selectors.tooltip)
    
    this.$firstLink = this.$links.first().attr('href')
    
    $(window).on("load", this.__handleInitialization.bind(this))
    $(window).on("resize", this.__handleInitialization.bind(this))
    $(document).on("click", this.__handleDocumentScrollState.bind(this))

    this.$subMenuTriggers.on("click", this.__handleSubMenuActiveState.bind(this))
    this.$links.on("mouseover", this.__handleSubMenuImageActiveState.bind(this))
  },

  __handleInitialization: function() {
   this.__handleWrapElements()
   this.__handleImageActiveState()
   this.__handleAddTriggerButton()
   this.__handleContactButtonsEvent()
  },

  __handleWrapElements: function() {
    $('.off-canvas__body .sub-navigation .ctas .button:eq(0), .off-canvas__body .sub-navigation .ctas .button:eq(1)').wrapAll("<div></div>")
  },

  __handleImageActiveState: function() {
    const $getFirstInstance = this.$images.filter((index, item) => item.dataset.link == this.$firstLink)
    $getFirstInstance.addClass('is-active')
  },

  __handleAddTriggerButton: function() {
    this.$hasSubMenu.each(function() {
      $(this).append('<button class="sub-menu-trigger"><img src="/wp-content/themes/alden-properties/assets/images/submenu.svg" /></button>')
    })
  },

  __handleSubMenuActiveState: function(event) {
    const $currentTarget = $(event.$currentTarget)
    $currentTarget.toggleClass('is-opened')
    $currentTarget.siblings('.submenu').slideToggle() 
  },

  __handleSubMenuImageActiveState: function(event) {
    const currentLink = $(event.currentTarget).attr('href')
    const $getMatchImage = this.$images.filter((index, item) => item.dataset.link == currentLink)

    $getMatchImage.addClass('is-active').siblings().removeClass('is-active')
  },

  __handleDocumentScrollState: function() {
    this.$element.hasClass('is-open') ? $('body').css('overflow', 'hidden') : $('body').css('overflow', 'initial')
  },

  __handleContactButtonsEvent: function() {
    if ($(window).width() > 1024) {
      this.$ctas.each(function() {
        if ( $(this).attr('href').includes('tel') ) {
          let phoneNumber = $(this).attr('href').split(':')

          $(this).on('click', (e) => {
            e.preventDefault()
            $(this).next().toggleClass('is-show')
          })

          $(document).mouseup((e) => {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0) {
              if (this.$tooltip) {
                this.$tooltip.removeClass('is-show')
              }
            }
          })

          $(this).after('<span class="nav-tooltip">'+ phoneNumber[1] +'</span>')
        }
      })
    }
  }
})